import { render, staticRenderFns } from "./DigitalCertificate.vue?vue&type=template&id=54f9593e&scoped=true&"
import script from "./DigitalCertificate.vue?vue&type=script&lang=js&"
export * from "./DigitalCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCertificate.vue?vue&type=style&index=0&id=54f9593e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9593e",
  null
  
)

export default component.exports